import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CommonService } from '../../common/services/common.service';
import { UserRequest } from '../../models/userdetails';

@Injectable()
export class ForgotPasswordService {

  constructor( private http: HttpClient, private _commonService: CommonService ) { }

  generatePassword(userDetails) {
      const params = {
              Email: userDetails
      };
      return this.http.post(this._commonService.baseUrl + 'generateforgotpassword', params);
  }

  updatePassword(rq){
      return this.http.post(this._commonService.baseUrl+'updatepassword',rq);
  }


}
